import { FC, PropsWithChildren } from 'react';
import { Accept, DropEvent, FileRejection, useDropzone } from 'react-dropzone';

interface FileDropzoneProps {
	accept?: Accept;
	maxSize?: number;
	maxFiles?: number;
	disabled?: boolean;
	onChange: <T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) => void;
	dragActiveComponent?: JSX.Element;
}

export const FileUploaderDropzone: FC<PropsWithChildren<FileDropzoneProps>> = ({
	accept,
	maxSize,
	maxFiles,
	disabled,
	onChange,
	dragActiveComponent,
	children,
}) => {
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop: onChange,
		accept,
		maxSize,
		maxFiles,
		disabled,
	});

	return (
		<div {...getRootProps()}>
			<input {...getInputProps()} />
			{isDragActive ? <>{dragActiveComponent ?? children} </> : <>{children}</>}
		</div>
	);
};
